import React, {PureComponent} from 'react'
import {connect} from'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import addImage from "../../img/icons/add.svg"
import chevronImage from "../../img/icons/chevron.svg"
import SVGSymbol from "../SVGSymbol"
import {openDropdown, closeDropdown} from "../../actions"
import Transition from 'react-transition-group/Transition';
import {TweenLite} from 'gsap'
import {canUseDom} from "../../utils/dom"

const TRANSITION_DURATION_SECONDS = 0.25;

const DropDownCaret = ({classes, className, open}) => {
    return <SVGSymbol icon={addImage} className={cn(classes.icon, className, {open})} />
}

const ChevronDropDownCaret = ({classes, className, open}) => {
    return <SVGSymbol icon={chevronImage} className={cn(classes.icon, className, {openChevron: open})} />
}

class DropDown extends PureComponent {

    componentWillMount() {
        if(canUseDom) document.addEventListener('click', this._onOutsideClick, false);
    }

    componentWillUnmount() {
        if(canUseDom) document.removeEventListener('click', this._onOutsideClick, false);
    }

    _onOutsideClick = (e) => {
        const {open, id, handleClose} = this.props
        if(!open) return;
        handleClose(id);
    }

    _handleDropdown = (e) => {
        const {open, id, handleClose, handleOpen} = this.props
        if(open) handleClose(id);
        else handleOpen(id);
        this._preventDefault(e)
    }

    _preventDefault = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    _onChange = (e, value) => {
        const {onChange} = this.props;
        if(onChange) onChange(value);
    }

    _onExiting = (node) => {
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {height: '0', display: 'none'})
    }

    _onEntering = (node) => {
        const {dropDownHeight=150} = this.props
        TweenLite.set(node, {display: 'block', height: '0%'})
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {height: `${dropDownHeight}`})
    }


    render() {
        const {classes, className, title, label, value, options, textOptions, open, dropDownClassName, caretClassName, chevronCaret = false, hoverOpen = false} = this.props;

        return <div onClick={!hoverOpen && this._handleDropdown} onMouseEnter={hoverOpen && this._handleDropdown} className={cn(classes.container, className, {open})}>
                {label}
                {chevronCaret ? <ChevronDropDownCaret classes={classes} className={caretClassName} open={open} /> : <DropDownCaret classes={classes} className={caretClassName} open={open} />}
                <Transition in={open} timeout={TRANSITION_DURATION_SECONDS*1000} onEntering={this._onEntering} onExiting={this._onExiting}>
                    {(state) => ( <ul className={cn(classes.list, dropDownClassName)}>
                            {title && <li className={classes.listItem} onClick={this._preventDefault}>{title}</li>}
                            {options && options.map((option, i) => <li key={option} className={classes.listItem}>
                              <a onClick={(e) => this._onChange(e, option)} className={cn( classes.link, {selected: option === value} )}>{textOptions ? textOptions[i] : option}</a></li>
                            )}
                    </ul>)}
                </Transition>
            </div>

    }
}

const mapStateToProps = (state, props) => {
    return {
        open: state.dropdown.open && state.dropdown.id === props.id,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleOpen: ( id ) => {
            dispatch(openDropdown(id))
        },
        handleClose: ( id ) => {
            dispatch(closeDropdown(id))
        },
    }
}

export default injectSheet( (theme) => ({
    container:{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        position: 'relative',
        transition: 'color 0.15s ease',
        "&:hover": {
            color: theme.colors.primary
        },
        ...theme.font.title.h4,
        '&.open, &.selected': {
            color: theme.colors.primary
        }
    },
    icon: {
        marginLeft: 10,
        marginTop: -1,
        width: 11,
        height: 11,
        transition: `transform 0.1s ease-in-out`,
        '&.open': {
            transform: 'rotate(45deg)',
        },
        "&.openChevron": {
            transform: 'rotate(180deg)',
        }
    },
    list: {
        position: 'absolute',
        overflow: 'hidden',
        top: 'calc(100% + 18px)',
        minWidth: 200,
        zIndex: theme.zIndex.dropdown,
        listStyle: 'none',
        margin: '0',
        padding: '0',
        backgroundColor: theme.colors.white,
        //boxShadow: '-5px 5px 5px 1px rgba(0,0,0,0.05), 5px 5px 5px 1px rgba(0,0,0,0.05)',
        //opacity: 0,
        display: 'none',
    },
    listItem: {
        margin: 10,
        color: theme.colors.text,
        fontSize: theme.getRemValue(13),
        ...theme.font.familyBoldStyle
    },
    link: {
        display: 'block'
    }
}))(connect(mapStateToProps, mapDispatchToProps)(DropDown))





// WEBPACK FOOTER //
// ./src/components/Widgets/SingleDropDown.js